import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../../../config";
import AuthContext from "../../../../context/AuthContext";
import styles from "./styles/KotelnyeDetails.module.scss";

function KotelnyeDetails({ selectedBoilerRoom }) {
  const { authTokens } = useContext(AuthContext);
  const [hasSchema, setHasSchema] = useState(false);
  const [schemaUrl, setSchemaUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (selectedBoilerRoom) {
      setLoading(true);
      setHasSchema(selectedBoilerRoom.newtwork_schema !== null);
      setSchemaUrl(selectedBoilerRoom.newtwork_schema);
      setLoading(false);
    }
  }, [selectedBoilerRoom]);

  return (
    <div className={styles.container}>     
      {loading ? (
        <p className={styles.loading}>Загрузка данных...</p>
      ) : hasSchema ? (
        <div className={styles.schemaContainer}>
          <img 
            src={schemaUrl} 
            alt={`Схема котельной ${selectedBoilerRoom.address}`}
            className={styles.schemaImage}
          />
          <button
            className={styles.schemaButton}
            onClick={() => window.open(schemaUrl, "_blank")}
          >
            Открыть схему в новом окне
          </button>
        </div>
      ) : (
        <p className={styles.noSchemaMessage}>
          Схема для выбранной котельной отсутствует
        </p>
      )}
    </div>
  );
}

export default KotelnyeDetails;